import A from 'utils/metrics/analytic'

// Открытие статьи
enum originArticle {
  LIBRARY = 'library',
  RECOMENDATION = 'recomendation',
  FEED = 'feed',
  LANDING = 'landing',
}

const A_art_openArticle = (origin: originArticle) => {
  A.setEvent('article_open', { origin })
  console.log('Открытие Стать от ', origin)
}

export { A_art_openArticle, originArticle }
